// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"131":"b573651b","630":"bdaf673b","879":"7aae30fe"}[chunkId] + ".js";
};